<div class="user-view-products-header">
  <h2 class="user-view-products-header__title">{{ getHeaderTitle() }}</h2>
  <span class="user-view-products-header__close material-icons" (click)="closeSideNav()">close</span>
</div>

<main class="user-view-products-body">

  @if (currentStep === ViewProductsStep.PRODUCTS) {
    @if (isLoading) {
      <div class="loading-container">
        <seds-loaders-bar style="width: 100%"></seds-loaders-bar>
        <span>Aguarde enquanto carregamos as informações do usuário.</span>
      </div>
    } @else {
      @if (isPmeLimitReached()) {
        <div class="limit-reached-banner" role="alert" aria-live="polite">
          <span class="limit-reached-banner__icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 22C10.0222 22 8.08879 21.4135 6.4443 20.3147C4.79981 19.2159 3.51809 17.6541 2.76121 15.8268C2.00433 13.9996 1.8063 11.9889 2.19215 10.0491C2.578 8.10929 3.53041 6.32746 4.92894 4.92894C6.32746 3.53041 8.10929 2.578 10.0491 2.19215C11.9889 1.8063 13.9996 2.00433 15.8268 2.76121C17.6541 3.51809 19.2159 4.79981 20.3147 6.4443C21.4135 8.08879 22 10.0222 22 12C21.9971 14.6513 20.9426 17.1931 19.0679 19.0679C17.1931 20.9426 14.6513 21.9971 12 22ZM12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V16C11 16.2652 11.1054 16.5196 11.2929 16.7071C11.4804 16.8946 11.7348 17 12 17C12.2652 17 12.5196 16.8946 12.7071 16.7071C12.8946 16.5196 13 16.2652 13 16V12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11ZM11 7V9L13 9V7L11 7Z" fill="#1E437A"/>
            </svg>
          </span>
          <div class="limit-reached-banner__content">
            <strong>Limite de acessos atingido</strong>
            <span>
              Revise os acessos existentes e exclua os que não forem necessários para criar novos usuários a partir deste usuário.
            </span>
          </div>
        </div>
      }

      <pl-step-products
        [cloneableLogon]="cloneableLogonData"
        [subtitle]="getDescription()"
        contentTextForInformation="Você pode criar um usuário sem vincular nenhum produto ou voltar para selecionar outro acesso."
        [hasError]="hasSearchError"
        [errorMessage]="searchErrorMessage"
      ></pl-step-products>
    }
  }

  @if (currentStep === ViewProductsStep.FORM) {
    <pl-step-form
      [entriesForm]="entriesForm"
      [cloneableLogon]="cloneableLogonData"
      [errorMessage]="errorMessage"
      [hasError]="hasCloneError"
      [isLoading]="createLogonLoading"
      [failedEmails]="failedEmails"
      [pmeLogonsCount]="pmeLogonsCount"
      [pmeLimitsUnavailable]="pmeLimitsUnavailable"
      [pmeLimitReached]="isPmeLimitReached()"
    ></pl-step-form>
  }
</main>

<pl-action-footer>
  <div class="action-footer">
    @if (canGoBack()) {
      <div
        class="action-footer__back"
        (click)="goBack()"
        launchLabel="Voltar"
        launchSection="Clique"
        launchSiteSection="PortalDeLogons"
        plAnalyticsButton
      >
        <span class="material-icons">arrow_back_ios</span>
        <span>Voltar</span>
      </div>
    } @else {
      <div></div>
    }

    <!-- Next/Action button -->
    <seds-basic-button
      class="action-footer__next"
      type="button"
      [title]="getNextButtonTitle()"
      [disabled]="isNextButtonDisabled()"
      (click)="onNextButtonClick()"
      launchLabel="{{ getNextButtonTitle() }}"
      launchSection="Clique"
      launchSiteSection="PortalDeLogons"
      plAnalyticsButton
    ></seds-basic-button>
  </div>
</pl-action-footer>
